import { Reveal } from "@/components/site/Reveal";
import { TESTIMONIALS } from "@/lib/data";

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="bg-olive-soft py-28 lg:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="max-w-3xl mb-16">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-olive">
            <span className="h-[1px] w-10 bg-olive" /> In their words
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-[var(--astera-char)]">
            The care women wish they'd found <span className="italic text-clay">sooner.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <div
              data-testid={`testimonial-card-${i}`}
              className="h-full flex flex-col rounded-[24px] bg-bone border border-[#EAE6E1] p-9"
            >
              <span className="font-serif text-6xl leading-none text-olive/40">“</span>
              <p className="mt-2 font-serif text-2xl leading-snug text-[var(--astera-char)] flex-1">
                {t.quote}
              </p>
              <div className="mt-8 flex items-center gap-4">
                <img
                  src={t.img}
                  alt={t.name}
                  className="h-12 w-12 rounded-full object-cover grayscale"
                />
                <div>
                  <p className="text-sm font-medium text-[var(--astera-char)]">{t.name}</p>
                  <p className="text-xs text-[var(--astera-char)]/50">{t.detail}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
